import type { ComponentProps } from 'react';

import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { StarterDashboardV2PageDataContextProvider } from 'src/app/pages/starterDashboardV2/pageContext';

import { EmailDecisionMakerModalBody } from './components/EmailDecisionMakerModalBody';

type ModalOptions = {
	pageData: ComponentProps<typeof StarterDashboardV2PageDataContextProvider>['pageData'];
};

export const useEmailDecisionMakerModalBase = createModalHook<ModalOptions>({
	name: 'EmailDecisionMakerModal',
	title: 'Decision Makers',
	body: function EmailDmModal() {
		return <EmailDecisionMakerModalBody />;
	},
	decorator: ({ children, options: { pageData } }) => {
		return (
			<StarterDashboardV2PageDataContextProvider pageData={pageData}>
				{children}
			</StarterDashboardV2PageDataContextProvider>
		);
	},
});
